import React from 'react'
import {Link} from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import './CrmReturnLink.scss'

// "[←] Client Name": Person Detail's outlined back box and the person's name,
// together one link to their CRM page. Callers own the data; `onClick` runs
// before the navigation. `crmReturn` tells Person Detail's Back not to pop
// back to this page.
export const CrmReturnLink = ({person, onClick}) => (
    <Link
        to={`/crm/people/${person.id}`}
        state={{crmReturn: true}}
        onClick={onClick}
        className={'crm-return'}
        aria-label={`Back to ${person.name}`}
        title={person.name}
    >
        <span className={'crm-return-box'}>
            <ArrowBackIcon style={{fontSize: 18}}/>
        </span>
        <span className={'crm-return-name'}>{person.name}</span>
    </Link>
)
